import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { Body3 } from '../../../../../../atomic/text/Text';

export const Direction = ({ alert }) => {
  return (
    <td>
      <Body3
        color={
          alert.goLong && alert.goShort
            ? colors.blue
            : alert.goLong
              ? colors.green
              : colors.red
        }
        fontWeight={500}
      >
        {alert.goLong && alert.goShort
          ? 'Both'
          : alert.goLong
            ? 'Long'
            : 'Short'}
      </Body3>
    </td>
  );
};

Direction.propTypes = {
  alert: PropTypes.shape({
    goLong: PropTypes.any,
    goShort: PropTypes.any,
  }),
};
